import React, { useEffect } from "react";
import { resolveImage } from "../../lib/api";

const upsertMetaTag = (selectorAttrs, value) => {
  const sel = Object.entries(selectorAttrs).map(([k, v]) => `[${k}="${v}"]`).join("");
  let el = document.head.querySelector(`meta${sel}`);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    Object.entries(selectorAttrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SCHEMA_ID = "rg-jsonld";
const upsertJsonLdBlocks = (blocks) => {
  // Remove all previous schema scripts inserted by us
  document.querySelectorAll(`script[data-rg-schema="true"]`).forEach((n) => n.remove());
  blocks.filter(Boolean).forEach((block) => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.setAttribute("data-rg-schema", "true");
    try {
      const parsed = JSON.parse(block);
      s.text = JSON.stringify(parsed);
    } catch {
      s.text = block;
    }
    document.head.appendChild(s);
  });
};

const Seo = ({
  title,
  description,
  keywords,
  ogImage,
  ogType,
  ogUrl,
  twitterCard,
  canonicalUrl,
  jsonLd,
  organizationSchema,
}) => {
  useEffect(() => {
    const resolvedOg = resolveImage(ogImage);
    if (title) document.title = title;
    upsertMetaTag({ name: "description" }, description);
    upsertMetaTag({ name: "keywords" }, keywords);

    upsertMetaTag({ property: "og:title" }, title);
    upsertMetaTag({ property: "og:description" }, description);
    upsertMetaTag({ property: "og:image" }, resolvedOg);
    upsertMetaTag({ property: "og:type" }, ogType || "website");
    upsertMetaTag({ property: "og:url" }, ogUrl || (typeof window !== "undefined" ? window.location.href : ""));

    upsertMetaTag({ name: "twitter:card" }, twitterCard || (resolvedOg ? "summary_large_image" : "summary"));
    upsertMetaTag({ name: "twitter:title" }, title);
    upsertMetaTag({ name: "twitter:description" }, description);
    upsertMetaTag({ name: "twitter:image" }, resolvedOg);

    upsertLink("canonical", canonicalUrl || (typeof window !== "undefined" ? window.location.href : ""));

    upsertJsonLdBlocks([organizationSchema, jsonLd]);
  }, [title, description, keywords, ogImage, ogType, ogUrl, twitterCard, canonicalUrl, jsonLd, organizationSchema]);
  return null;
};

export default Seo;
